import React from 'react'
import { STATUS_META } from './invoiceStatus'

function fmtCurrency(n) {
  if (n == null) return '—'
  return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function fmtDate(d) {
  if (!d) return '—'
  return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export default function InvoiceListItem({ invoice, selected, onClick }) {
  const meta = STATUS_META[invoice.status] || { label: invoice.status, bg: '#f2f5f6', color: '#607d8b' }
  const vendorName = invoice.vendor?.name || '—'
  const siteName = invoice.scheduleItem?.siteName || invoice.entity?.name || '—'
  const final = invoice.finalAmount != null ? invoice.finalAmount : invoice.amount
  const needsPricingReview = invoice.pricingStatus === 'needs_review'

  return (
    <tr
      className={selected ? 'selected' : ''}
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <td className="id">{invoice.invoiceNumber || '—'}</td>
      <td className="desc">
        {vendorName}
        <small>{siteName}</small>
      </td>
      <td className="num">{fmtCurrency(final)}</td>
      <td>
        <span
          style={{
            display: 'inline-block',
            padding: '2px 8px',
            borderRadius: 4,
            fontSize: '11px',
            fontWeight: 600,
            background: meta.bg,
            color: meta.color,
          }}
        >
          {needsPricingReview ? 'Pricing Review' : meta.label}
        </span>
      </td>
      <td style={{ color: 'var(--ink-3)', fontSize: '12px' }}>{fmtDate(invoice.created_at)}</td>
    </tr>
  )
}
